import { combineReducers } from 'redux';
import { routerReducer } from '../history';
import { chatReducer } from './chat';
import { chatSessionReducer } from './chat-session';
import { fileUploadReducer } from './file-upload';
import { httpRequestsReducer } from './http-requests';
import { i18nReducer } from './i18n';
import { messagesReducer, messageActionLogReducer } from './messages';
import { notificationsReducer } from './notifications';
import { operatorsReducer } from './operator';
import { dialogReducer } from './sg-dialog';
import { debugLogsReducer } from './debug';
import { salesPromotionReducer } from './sales-promotion';
import { prefillUserDataReducer } from './user-prefill-data';
import { optionsReducer } from './options';

/**
 * @typedef {Object} Store
 * @property { import('./messages').MessagesReducer } messages
 * @property { import('./operator').OperatorReducer } operators
 */

const createRootReducer = combineReducers({
  chat: chatReducer,
  chatSession: chatSessionReducer,
  options: optionsReducer,
  dialog: dialogReducer,
  messages: messagesReducer,
  notifications: notificationsReducer,
  operators: operatorsReducer,
  router: routerReducer,
  upload: fileUploadReducer,
  i18n: i18nReducer,
  messageActionLogReducer,
  httpRequests: httpRequestsReducer,
  debugLogs: debugLogsReducer,
  salesPromotion: salesPromotionReducer,
  prefillUserData: prefillUserDataReducer
});

export default createRootReducer;
